import React, { useState, useEffect, useRef } from "react";
import "./faq.css";
import { ChevronDown } from "lucide-react";

const faqData = [
  {
    question: "Who can use Poonji Mitra?",
    answer:
      "Our platform is ideal for anyone looking to grow their wealth, whether you're a first-time investor or a seasoned trader, especially if you're from Tier 2 or Tier 3 cities.",
  },
  {
    question: "What investment products do Poonji Mitra offer?",
    answer:
      "Our platform is ideal for anyone looking to grow their wealth, whether you're a first-time investor or a seasoned trader, especially if you're from Tier 2 or Tier 3 cities.",
  },
  {
    question: "Can I get help if I'm unsure where to invest?",
    answer:
      "Our platform is ideal for anyone looking to grow their wealth, whether you're a first-time investor or a seasoned trader, especially if you're from Tier 2 or Tier 3 cities.",
  },
  {
    question: "Do you offer customer support?",
    answer:
      "Yes, we provide 24/7 customer support through chat, email, and phone to assist with any queries",
  },
  {
    question: "How do I get started with Poonji Mitra?",
    answer:
      "Download our app or visit our website, create an account, and start exploring investment opportunities tailored to your goals, or you can just contact us at  +91 78510 03243",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  /* SAFE scroll reveal */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-visible");
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <section ref={sectionRef} className="faq-section reveal-item">
      <div className="faq-container">
        {/* Header */}
        <div className="faq-header">
          <span className="faq-badge">WE'VE GOT YOU COVERED</span>
          <h2 className="faq-title">Frequently Asked Questions</h2>
        </div>

        {/* FAQ List */}
        <div className="faq-list">
          {faqData.map((faq, index) => {
            const isOpen = activeIndex === index;

            return (
              <div
                key={index}
                className={`faq-item ${isOpen ? "open" : ""}`}
                onClick={() => toggleFAQ(index)}
              >
                <div className="faq-question-area">
                  <h3 className="faq-question">{faq.question}</h3>

                  <ChevronDown
                    className={`faq-icon ${isOpen ? "rotate" : ""}`}
                    size={20}
                  />
                </div>

                <div className="faq-answer-wrapper">
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
